<script setup lang="ts">
import type { AccordionTriggerProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { ChevronDown } from 'lucide';
import {
    AccordionHeader,
    AccordionTrigger,
} from 'reka-ui';
import SphIcon from '@/components/base/icon/';
import { cn } from '@/utils/shadcn/lib/utils.ts';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps<AccordionTriggerProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
    <AccordionHeader class="flex">
        <AccordionTrigger
            data-slot="accordion-trigger"
            v-bind="delegatedProps"
            :class="
                cn(
                    'flex flex-1 items-start justify-between gap-4 rounded-md py-4 text-left text-sm font-medium transition-all duration-400 outline-none disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>.sph-icon]:rotate-180',
                    props.class,
                )
            "
        >
            <slot></slot>
            <slot name="icon">
                <SphIcon
                    :icon="ChevronDown"
                    size="sm"
                    class="text-muted-foreground pointer-events-none shrink-0 translate-y-0.5 transition-transform duration-400"
                />
            </slot>
        </AccordionTrigger>
    </AccordionHeader>
</template>
